import axios from "axios";
import env from "../env";

// Generate OTP 
export const generateSecondaryOtp = (email) => {
  const token = localStorage.getItem("token");
  const umURL = env.GET_USERMANAGEMENT_API_URL();
  const body = {
    email,
    transactionType: "SecondaryLogin",
    language: "en",
    appId: "test",
  };
  const config = {
    headers: {
      "Content-Type": "application/json",
      //...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  return axios.post(`${umURL}/simplifi/v1/otpManagement/secondaryOtpGeneration`, body, config);
};

// Validate OTP 
export const validateSecondaryOtp = (email, otp) => {
  const token = localStorage.getItem("token");
  const umURL = env.GET_USERMANAGEMENT_API_URL();
  const body = {
    otp,
    email,
    transactionType: "SecondaryLogin",
  };
  const config = {
    headers: {
      "Content-Type": "application/json",
      //...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  return axios.post(`${umURL}/simplifi/v1/otpManagement/secondaryOtpValidation`, body, config);
};
